import Footer from '@/components/Footer';
import Head from '@/components/Head';
import { Helmet } from 'react-helmet-async';
import Menu from '@/components/Menu';
import MenuMobile from '@/components/MenuMobile';
import { Outlet } from 'react-router-dom';

// No styled-components here — static CSS classes in index.html.
// SC hydration modifies <style data-styled> tags for any SC element; even pure-CSS
// children (like .infobar-critical) get caught in the resulting style recalculation.
// By removing SC from these layout ancestors the Infobar <p> (LCP element) is
// fully isolated from SC's repaint cycle.
const Layout = () => {
  return (
    <>
      <Helmet>
        <title>MAZOUT.COM</title>
        <meta name='robots' content='index' />
      </Helmet>

      <Head />

      {/* CSS-only responsive menus: identical on SSR and client, no layout shift */}
      <div className='mobile-only-nav'>
        <MenuMobile />
      </div>
      <div className='desktop-only-nav'>
        <Menu />
      </div>

      <main className='main-layout'>
        <Outlet />
      </main>

      <Footer />
    </>
  );
};

export default Layout;
